/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_Live_FallbackInputs */

const vi_vehicle_camera_live_fallback = /** @type {(inputs: Vehicle_Camera_Live_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không mở được live, đang dùng ảnh mới nhất.`)
};

/**

* @param {Vehicle_Camera_Live_FallbackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_live_fallback = /** @type {((inputs?: Vehicle_Camera_Live_FallbackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_Live_FallbackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_live_fallback(inputs)
});